// Catalog category names come back from the API verbatim in English (matching
// the JSON keys), and each vertical has its OWN category tree — so each has its
// own translation namespace. The shared `categories` namespace covers SERVICE
// categories plus generic entries such as OTHER, so it stays last in the chain
// as a fallback; without it catalog category names render in raw English.
//
// Pass the result straight to `t(name, { ns: categoryNamespaces(vertical) })` —
// i18next walks the array in order and takes the first namespace that has the key.
export const categoryNamespaces = (vertical) => [
  vertical === "restaurants" ? "restaurants_categories" : "products_categories",
  "categories",
];

// Services have no vertical of their own — they live in the shared namespace.
export const SERVICE_CATEGORY_NAMESPACES = ["categories"];

export default categoryNamespaces;
